export const PROFILE_PURCHASE_TYPE_FREE = 1;

export const PROFILE_DEFAULT_MODE = 0;
export const PROFILE_SAFE_MODE = 1;

export const MAN_OPEN_TO_WOMEN = "1";
export const WOMAN_OPEN_TO_MEN = "2";
export const MAN_OPEN_TO_MEN = "3";
export const MAN_OPEN_TO_EVERYONE = "4";
export const WOMAN_OPEN_TO_WOMEN = "5";
export const WOMAN_OPEN_TO_EVERYONE = "6";

export const GENDER_PREFER = {
  [MAN_OPEN_TO_WOMEN]: "manOpenToWomen",
  [MAN_OPEN_TO_MEN]: "manOpenToMen",
  [MAN_OPEN_TO_EVERYONE]: "manOpenToEveryone",
  [WOMAN_OPEN_TO_MEN]: "womanOpenToMen",
  [WOMAN_OPEN_TO_WOMEN]: "womanOpenToWomen",
  [WOMAN_OPEN_TO_EVERYONE]: "womanOpenToEveryone",
};

export const genderPreferenceMap = {
  "1,2": MAN_OPEN_TO_WOMEN,
  "2,1": WOMAN_OPEN_TO_MEN,
  "1,1": MAN_OPEN_TO_MEN,
  "1,3": MAN_OPEN_TO_EVERYONE,
  "2,2": WOMAN_OPEN_TO_WOMEN,
  "2,3": WOMAN_OPEN_TO_EVERYONE,
};

export const PREFERENCE_ORDER = [
  MAN_OPEN_TO_WOMEN - 1,
  MAN_OPEN_TO_MEN - 1,
  MAN_OPEN_TO_EVERYONE - 1,
  WOMAN_OPEN_TO_MEN - 1,
  WOMAN_OPEN_TO_WOMEN - 1,
  WOMAN_OPEN_TO_EVERYONE - 1,
];

export const CREDITS_REMINDER_LIMIT = 12;
